module.exports = __webpack_public_path__ + "static/media/29COICT8.8b3b3c64.jpg";